import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {getTableList, exportData} from './service'

const model = createProjectModel({
    namespace: 'interactionRanking',

    state: {
        tableList: {},
    },

    effects: {
        *getTableList(xx, {select, put, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }

            if (newParams.time) {
                newParams.st_month = newParams.time.format('YYYY-MM')
                delete newParams.time
            }

            const res = yield call(getTableList, {params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })

            return res
        },

        // 导出数据
        *exportData(xx, {call, select}) {
            const {tableList} = yield select((allState) => allState[model.namespace])

            const newParams = {
                ...tableList.params,
            }

            if (newParams.time) {
                newParams.st_month = newParams.time.format('YYYY-MM')
                delete newParams.time
            }

            return yield call(exportData, {params: newParams})
        },
    },
})

export default model
